import ptBr from "./texts/pt-br";

const texts = {
  "pt-BR": ptBr,
  "en-US": ptBr,
};

export default texts;
